import { Event as TEvent } from "../../../../Global/Base/Events";
import { Localization } from "../../../../OW.Remoting/Remoting/Localization";
import { ChartType } from "../../../UI.Controls/ChartElement";
import { createElement } from "../../../UI.ElementarControls/Utils/CustomElementUtils";
import { IContentBuilder } from "./IContentBuilder";
/**
 * třída představuje hlavičku ChartSettingsPanelu
 * obsahuje tlačítka typ grafu
 */
export class ChartSettingsHeaderBuilder implements IContentBuilder {
    /** událost změna typu grafu */
    public chartTypeChanged: TEvent<ChartType, void> = new TEvent<ChartType, void>();
    private _element: HTMLElement;
    private _listenerClickBar: EventListener;
    private _listenerClickPie: EventListener;
    private _listenerClickLine: EventListener;
    /** pole tlačítek typ grafu */
    private _chartElementArray: Array<HTMLElement> = [];
    private _chartType: ChartType;
    private _cssClass: string = "chart-settings-header-builder";

    constructor(chartType: ChartType) {
        this._chartType = chartType;
        this._initialize();
        this.chartTypeChanged.add((chartType: ChartType) => this.changeChartType(chartType));
    }

    private _initialize(): void {
        this._element = createElement({ classes: [this._cssClass] });

        this._chartElementArray.push(this._addNewChart("web-chart", this._listenerClickBar = () => this.chartTypeChanged.trigger(ChartType.bar, null), ChartType.bar, "GUI-680142")); //Sloupcový graf
        this._chartElementArray.push(this._addNewChart("doc-pie", this._listenerClickPie = () => this.chartTypeChanged.trigger(ChartType.pie, null), ChartType.pie, "GUI-680145")); //Koláčový graf
        this._chartElementArray.push(this._addNewChart("doc-analytics-up", this._listenerClickLine = () => this.chartTypeChanged.trigger(ChartType.line, null), ChartType.line, "GUI-680146")); //Spojnicový graf

        this.changeChartType(this._chartType);
    }

    /**
     * přidá nové tlačítko typ grafu
     * @param chartIcon: string = ikona tlačítka
     * @param action: funkce = funkce při kliknutí na tlačítko
     * @param chartType: ChartType = do atributu data-chartType vloží typ grafu, který tlačítko představuje
     */
    private _addNewChart(chartIcon: string, action: (...params: any[]) => void, chartType: ChartType, titleLocKey: string): HTMLElement {
        const newChart = createElement({ type: "button", classes: ["Icon", chartIcon, "btn", "flat", this._cssClass + "__icon", "ToolbarButton"], attrs: { "data-chartType": chartType } });
        newChart.addEventListener("click", () => {
            if (newChart.classList.contains("Disabled")) {
                return;
            }
            action();
        });
        Localization.addLocData(newChart, titleLocKey, "title");
        this._element.appendChild(newChart);
        return newChart;
    }

    /**
     * změnu typu grafu zanese do chartsettingsmanageru
     * @param chartType: ChartType = zvýrazní se tlačítko reprezentující daný typ grafu
     * @param changedManually: boolean = pokud je typ grafu měněn klikem, vyvolá se událost změny typu grafu
     */
    private changeChartType(chartType: ChartType): void {
        this._chartElementArray.forEach((mChart) => mChart.classList.remove("isActive"));
        this._setActiveChartType(this.getChartTypeSection(chartType));
    }

    /**
     * na více místech je chování grafu typu bar/horizontalbar, pie/doughnut totožné
     * @param chartType
     */
    public getChartTypeSection(chartType: ChartType): ChartType {
        switch (chartType) {
            case ChartType.bar:
                return ChartType.bar;
            case ChartType.pie:
            case ChartType.doughnut:
                return ChartType.pie;
            case ChartType.line:
                return ChartType.line;
            default:
                return ChartType.bar;
        }
    }

    /**
     * vrátí aktuálně zvolené tlačítko typ grafu
     */
    public getActiveChartType(): ChartType {
        for (const mChart of this._chartElementArray) {
            if (mChart.classList.contains("isActive")) {
                return mChart.getAttribute("data-chartType") as ChartType;
            }
        }
        return null;
    }

    /**
     * zvýrazní tlačítko reprezentující aktuálně vybraný typ grafu
     */
    private _setActiveChartType(chartType: ChartType): void {
        for (const mChart of this._chartElementArray) {
            if (mChart.getAttribute("data-chartType") == chartType) {
                mChart.classList.add("isActive");
                break;
            }
        }
    }

    public async build(): Promise<HTMLElement> {
        return this._element;
    }

    public dispose(): void {
        this._chartElementArray.forEach((mChart) => {
            switch (mChart.getAttribute("data-chartType")) {
                case ChartType.bar:
                    mChart.removeEventListener("click", this._listenerClickBar);
                    break;
                case ChartType.pie:
                    mChart.removeEventListener("click", this._listenerClickPie);
                    break;
                case ChartType.line:
                    mChart.removeEventListener("click", this._listenerClickLine);
                    break;
            }
        });
    }
}
